import React from "react";
import CustomButton from "./index";

const SFRoundedButton = (props) => {
  let buttonSize;
  switch (props.size) {
  case "small":
    buttonSize = 30;
    break;
  case "medium":
    buttonSize = 45;
    break;
  case "large":
    buttonSize = 60;
    break;
  default:
    buttonSize = 45;
    break;
  }

  return (
    <CustomButton
      {...props}
      sx={{
        borderRadius: "50%",
        height: buttonSize,
        width: buttonSize,
        minWidth: buttonSize,
        border: "none",
        fontSize: 16,
      }}
    >
      {props.children}
    </CustomButton>
  );
};

SFRoundedButton.defaultProps = {
  ...CustomButton.defaultProps,
};

SFRoundedButton.propTypes = {
  ...CustomButton.propTypes,
};

export default SFRoundedButton;